import React, { useMemo } from "react";
import PropTypes from "prop-types";
import ButtonBlock from "../../../components/Preview/Draggable/Block/ButtonBlock";
import styles from "./PostPurchaseCtaButton.module.css";

const SHOPIFY_BLUE = "#1773b0";

function normalizeButtonStyle(section, { primary = true } = {}) {
  const fromDisplay = section?.setting?.display?.postPurchaseButtonStyle;
  if (fromDisplay) {
    const raw = String(fromDisplay).toLowerCase();
    if (raw === "secondary" || raw === "plain") return raw;
    if (raw === "primary") return "primary";
  }
  return primary ? "primary" : "secondary";
}

function buildButtonCss(buttonStyle) {
  const base = {
    width: "100%",
    borderRadius: "4px",
    fontWeight: buttonStyle === "primary" ? "600" : "500",
    padding: "10px 16px",
    height: "auto",
    minHeight: "44px",
    maxHeight: "48px",
    lineHeight: "1.25",
    boxSizing: "border-box",
  };

  if (buttonStyle === "plain") {
    return {
      ...base,
      backgroundColor: "transparent",
      background: "transparent",
      color: SHOPIFY_BLUE,
      border: "none",
      boxShadow: "none",
    };
  }

  if (buttonStyle === "secondary") {
    return {
      ...base,
      backgroundColor: "#ffffff",
      background: "#ffffff",
      color: SHOPIFY_BLUE,
      border: `1px solid ${SHOPIFY_BLUE}`,
    };
  }

  return {
    ...base,
    backgroundColor: SHOPIFY_BLUE,
    background: SHOPIFY_BLUE,
    color: "#ffffff",
    border: `1px solid ${SHOPIFY_BLUE}`,
  };
}

function normalizePostPurchaseCtaSection(section, { primary = true } = {}) {
  if (!section) return section;

  const buttonStyle = normalizeButtonStyle(section, { primary });
  const buttonCss = buildButtonCss(buttonStyle);
  const customCSS = section.setting?.customCSS || {};
  const desktop = { ...(customCSS.desktop || {}), ...buttonCss };
  const mobile = { ...(customCSS.mobile || {}), ...buttonCss, width: "100%" };

  return {
    ...section,
    setting: {
      ...(section.setting || {}),
      layoutFlow: true,
      btn_type: { type: "text" },
      display: {
        ...(section.setting?.display || {}),
        postPurchaseButtonStyle: buttonStyle,
      },
      customCSS: { desktop, mobile },
    },
  };
}

const WRAP_CLASS = {
  primary: styles.primaryWrap,
  secondary: styles.secondaryWrap,
  plain: styles.plainWrap,
};

export default function PostPurchaseCtaButton({ primary = true, ...props }) {
  const buttonStyle = useMemo(
    () => normalizeButtonStyle(props.section, { primary }),
    [props.section, primary]
  );

  const section = useMemo(
    () => normalizePostPurchaseCtaSection(props.section, { primary }),
    [props.section, primary, buttonStyle]
  );

  return (
    <div className={WRAP_CLASS[buttonStyle] || styles.primaryWrap}>
      <ButtonBlock {...props} section={section} />
    </div>
  );
}

PostPurchaseCtaButton.propTypes = {
  primary: PropTypes.bool,
  section: PropTypes.object,
  popupData: PropTypes.object,
  popupState: PropTypes.object,
  setPopupState: PropTypes.func,
};
